var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { alpha, getContrastRatio } from '../styles/color-manipulator';
import { shadeMap } from './colors';
export var createMixins = function (_a) {
    var palette = _a.palette, tokens = _a.tokens, _b = _a.overrides, overrides = _b === void 0 ? {} : _b;
    var shadeOfColor = function (color, shade) {
        if (shade === void 0) { shade = 'base'; }
        var shadeValue = shadeMap[shade];
        return palette[color][shadeValue];
    };
    // `${color}:${shade}`: value
    var textColorCache = {};
    var textColorForShadeOfColor = function (color, shade) {
        if (shade === 'lightest') {
            return shadeOfColor(color, 'darkest');
        }
        var cacheKey = "".concat(color, ":").concat(shade);
        if (textColorCache[cacheKey]) {
            return textColorCache[cacheKey];
        }
        var bgColor = shadeOfColor(color, shade);
        var textPrimaryContrastRatio = getContrastRatio(palette.text.primary, bgColor);
        var whiteContrastRatio = getContrastRatio(palette.common.white, bgColor);
        var textColor = whiteContrastRatio >= textPrimaryContrastRatio ? palette.common.white : palette.text.primary;
        textColorCache[cacheKey] = textColor;
        return textColor;
    };
    var focusRing = function (options) {
        if (options === void 0) { options = {}; }
        var _a = options.color, color = _a === void 0 ? tokens.color_border_focus_bold : _a, _b = options.type, type = _b === void 0 ? 'default' : _b, _c = options.opacity, opacity = _c === void 0 ? palette.mode === 'light' ? 0.25 : 0.5 : _c;
        var shadow = "".concat(opacity === 1 ? color : alpha(color, opacity), " 0px 0px 0px 0.25em");
        return {
            boxShadow: type === 'default' ? shadow : "inset ".concat(shadow),
        };
    };
    var borderAsBoxShadow = function (color, width) {
        if (width === void 0) { width = 1; }
        return "inset 0px 0px 0px ".concat(width, "px ").concat(color);
    };
    var appBarAction = function () {
        var hoverStyles = {
            color: tokens.color_fg_inverse_static,
            backgroundColor: tokens.color_bg_link_inverse_static_hover,
        };
        return {
            root: {
                backgroundColor: 'transparent',
            },
            hover: hoverStyles,
            active: hoverStyles,
            focus: __assign({ color: tokens.color_fg_inverse_static }, focusRing({ color: tokens.color_border_focus_inverse_static, opacity: 1 })),
        };
    };
    var getColorModeValue = function (_a) {
        var light = _a.light, dark = _a.dark;
        if (palette.mode === 'dark') {
            return dark || '';
        }
        return light || '';
    };
    var mixins = __assign({ borderAsBoxShadow: borderAsBoxShadow, shadeOfColor: shadeOfColor, textColorForShadeOfColor: textColorForShadeOfColor, focusRing: focusRing, appBarAction: appBarAction, getColorModeValue: getColorModeValue }, overrides);
    return mixins;
};
